import api from '../config/api';

export const getUserNotifications = (accountId, pageNumber = 1, pageSize) =>
  api.get('api/v1/users/notifications', {
    page_size: pageSize,
    page: pageNumber,
    account_id: accountId
  });

export const setNotificationsSeen = accountId =>
  api.put('api/v1/users/seen_notifications', {
    account_id: accountId
  });

export const setNotificationAsRead = notificationId =>
  api.put(`api/v1/users/notifications/${notificationId}`);
